/* ============
 * License Type Transformer
 * ============
 *
 * The transformer for the licenseTypes.
 */

import Transformer from './transformer';

export default class licenseTypeTransformer extends Transformer {

  static fetch(licenseTypes) {
    return {
      id: licenseTypes.id,
      name: licenseTypes.name,
      code: licenseTypes.code,
    };
  }

  static send(licenseTypes) {
    return {
      id: licenseTypes.id,
      name: licenseTypes.name,
      code: licenseTypes.code,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/licenseType.js